import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-stone-50" data-id="element-309" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-310" data-mp="cn7soxye8i0x">
        <div className="text-center mb-16" data-id="element-311" data-mp="cm51eox5sdkh">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-blue-950" data-id="element-312" data-mp="7qhc89iofkez">
            THE 6-IN-1 DRIVING INSTRUCTOR READY SYSTEM
          </h2>
          <p className="text-xl text-slate-700" data-id="element-313" data-mp="3c3mjwgoanoz2">
            <span className="text-orange-600 font-semibold" data-id="element-314" data-mp="3c4xlc9u9okn0">150 Ready-to-Teach Lessons</span> ·
            Beginner to Test-Ready · Visual Teaching Tools · Nothing to Build From Scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-315" data-mp="3l2rjlqbldoct">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-orange-500 shadow-lg shadow-blue-950/10' : 'border-stone-200 shadow-sm shadow-blue-950/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-316" data-mp="2xd5j8zjhh338" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-orange-600 text-white font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-317" data-mp="1vfhbz8t5aon6">
                  MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-318" data-mp="24g5sca60h138">
                <span className="w-12 h-12 rounded-xl bg-blue-950 text-orange-500 font-serif font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-319" data-mp="24eb34jnpimtc">
                  {index + 1}
                </span>
                <div data-id="element-320" data-mp="1gozp5cur99pc">
                  <div className="text-blue-700 font-bold text-sm uppercase tracking-wider" data-id="element-321" data-mp="1gsnlskvhyc8a">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-blue-950" data-id="element-322" data-mp="1pqfxlf20f1qx">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-blue-950 font-semibold mb-6 border-l-4 border-orange-500 pl-4" data-id="element-323" data-mp="x3v9cngtz5rl">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-324" data-mp="16upybzlgojgq">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-800 text-sm leading-relaxed" data-id="element-325" data-mp="1203jfmg688rw">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-326" data-mp="2l0mdg5jjl5ju">
                      {volume.questions.map(question => <li key={question} className="text-blue-700 font-semibold text-sm bg-stone-50 border border-blue-700/20 rounded-lg px-3 py-2" data-id="element-327" data-mp="2prkrszkyztkg">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-white font-bold text-base bg-blue-950 border-l-4 border-orange-500 rounded-lg px-4 py-3" data-id="element-328" data-mp="38p5jsfj1789a">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-800 text-sm leading-relaxed" data-id="element-329" data-mp="1jb8s2u2i23mr">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-330" data-mp="1obwtm9ocu2v8">
                <div data-id="element-331" data-mp="1o88xr3vft4dc">
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-332" data-mp="23jyvq7vzd4jw">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-333" data-mp="1yta5swzy8fmv">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-334" data-mp="2mj4h3a4mdw50">
                        <CheckCircle2 size={18} className="text-green-600 shrink-0 mt-0.5" data-id="element-335" data-mp="2ihiw11hxmbjq" />
                        <span className="text-slate-800 text-sm" data-id="element-336" data-mp="2di68sfn5f2gm">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-337" data-mp="123j1k61uve3v">
                    <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-338" data-mp="123sofkrlt55c">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-339" data-mp="mzzmw9yzon0j">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-340" data-mp="rzcbaz5ie258">
                          <CheckCircle2 size={18} className="text-green-600 shrink-0 mt-0.5" data-id="element-341" data-mp="wx4bshk7ywl1" />
                          <span className="text-slate-800 text-sm" data-id="element-342" data-mp="11pxhb7nii8y6">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-343" data-mp="1fonfkqm2ieo4">
                  <p className="text-blue-950 font-semibold text-sm mb-2" data-id="element-344" data-mp="1fporsyetl77f">{volume.sequenceIntro}</p>
                  <p className="text-blue-700 font-bold text-sm bg-stone-50 border border-blue-700/20 rounded-lg px-3 py-2" data-id="element-345" data-mp="1kmp07fz56m1p">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-stone-50 border border-stone-200 border-l-4 border-l-green-600 rounded-xl p-4 mt-auto" data-id="element-346" data-mp="3mfmu7f4nnko8">
                <span className="text-blue-950 font-bold block mb-1" data-id="element-347" data-mp="3eg8hpggwkkoq">RESULT</span>
                {volume.resultLead && <p className="text-slate-800 text-sm" data-id="element-348" data-mp="3ocbk8nfo2lc7">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-blue-950" data-id="element-349" data-mp="3jdrxikt915is">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-800 text-sm" data-id="element-350" data-mp="16kkm729jact">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}